export default 'M3 4a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v17.43a2 2 0 0 1-3.04 1.71L12 19.5l-5.96 3.64A2 2 0 0 1 3 21.44z';